import script from "./control.vue?vue&type=script&lang=js"
export * from "./control.vue?vue&type=script&lang=js"

import "./control.vue?vue&type=style&index=0&id=5f051552&lang=css"

const __exports__ = script;

export default __exports__